var exports = {
  "z": "summary__linYAy",
  "uB": "planDialog__9FbT4Y",
  "kG": "dialogContent__JDHMsX",
  "ms": "dialogActions__b7-ZaE",
};

module.exports = exports;
